import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { Portal } from '@mui/base';
import PageLoader from '@sanedi.epc/components/common/page-loader';

const ModalLoader = () => (
  <Portal>
    <Dialog PaperProps={{ sx: { overflow: 'visible' } }} open>
      <DialogContent sx={{ pr: 0, pl: 0, overflow: 'visible' }}>
        <div style={styles.container}>
          <PageLoader/>
        </div>
      </DialogContent>
    </Dialog>
  </Portal>
);

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    minHeight: 512,
    minWidth: 512,
    justifyContent: 'center',
    alignItems: 'center'
  }
};

export default ModalLoader;